import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { deepCopy, getFormatedDataFormWidget, isDateTimeGetTimeSeconds, languagesList, languagesList_, prepareToSaveImages, removeUndefined, transformToNestedStructure } from 'na-lib';
import { DragFileBrowseData, widgetEditMode } from 'na-lib/dist/network/widgets.dto';
import { validColorValidator } from 'src/app/validators/color.validator';
import { CommentsService } from 'src/app/service/comments.service';
import { LocalStorageService } from 'src/app/service/local-storage-service.service';
import { SettingsService } from 'src/app/service/settings.service';
import { UploadService } from 'src/app/service/upload.service';
import { WidgetsService } from 'src/app/service/widgets.service';
import { widgetTranslationModeData } from 'src/app/shared/shared';
import { supportUrlStructure } from 'src/app/supportUrls';
import { urlInvalidCharactersValidator } from 'src/app/validators/formValidators.dt';

@Component({
    selector: 'app-widget-edit-dialog',
    templateUrl: './widget-edit-dialog.component.html',
    styleUrl: './widget-edit-dialog.component.css',
    standalone: false
})

export class WidgetEditDialogComponent {

  oldData:any
  url:any
  changes=false
  widgetNumber:any
  passId:any
  passTranslations:any
  oldTranslations:any
  addUrl = false
  selectedLanguage:string
  widgetId:string
  showOriginalActive = false
  languagesList = languagesList
  dragFileData:DragFileBrowseData
  dragFileDataOriginal:DragFileBrowseData
  passLanguagesList:any
  widgetsTranslatedForm!:FormGroup
  widgetsDataForm!:FormGroup
  title:any
  dataDefLanguage: widgetEditMode
  dataOriginal: widgetTranslationModeData
  defaultLanguage:string
  urlRegex = /^(?:\$\{[A-Za-z0-9._:-]+\}|(?:https?:\/\/|context:\/\/|pass:\/\/)\S+)$/;
  urlRegexDoc = /^(?:\$\{[^}]+\}|pass:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+)$/;
  urlRegexDocContext = /^context?:\/\/?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  dynamicUrl = false
  widgetData:any
  clickToSave = false
  returnedWidgetData:any
  saveDisabled = false 
  validForm = false
  widgetType:any

  constructor(public dialogRef: MatDialogRef<WidgetEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: widgetEditMode ,
    public dialog: MatDialog,
    private uploadService: UploadService,
    private commentService: CommentsService,
    private fb: FormBuilder,
    private translate:TranslateService,
    private settingsService: SettingsService,
    private localStorageService: LocalStorageService,
    private widgetService: WidgetsService){
      dialogRef.disableClose=true
      const currentLang = this.translate.currentLang() ?? 'en';
      this.languagesList = languagesList_[currentLang]
  }

  ngOnInit():void {

    this.passId = this.data.passId
    this.widgetId = this.data.widgetId
    this.defaultLanguage = this.data.defaultLanguage
    this.widgetData = this.data.values
    this.oldData = deepCopy(this.data.values)
    this.widgetNumber = this.data.widget
    this.passTranslations = deepCopy( this.data.translations )
    this.oldTranslations = deepCopy( this.data.translations )

    if(this.data.type){
      this.title = this.translate.instant('pass.widgets.types.' + this.data.type)
      this.widgetType = this.data.type
    }

    if(this.data.translateMode){
      this.dataDefLanguage = deepCopy(this.data)      
      this.dataDefLanguage.translateData.originalLanguageData = true
      this.initializeTranslationData(this.data.translateData, this.data.type)
      this.title += ' - ' + this.translate.instant('translationMode')
    }else
      this.initializeOriginalData(this.data.values, this.data.type)
  }


  initializeOriginalData(data, type){
    const layout = data.layout 
                  ? data.layout : 
                  (type === 'video' ? 'standard' : ( type === 'splashVideo' ? 'splash' : (type == 'billboardvideo' ? 'billboard' : 'standard')))
    switch(type){
      case 'billboardImage': {
        const {id, filter, imageSize, type, title, subtitle, url, linkURL, name, altTitle, fallbackUrl} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled :false}],
          imageSize:[{value: imageSize ? imageSize : undefined , disabled:false}],
          type:[{value:type ? type : undefined, disabled:false}],
          title:[{value: title ? title :undefined, disabled:false}],
          subtitle: [{value: subtitle ? subtitle : undefined, disabled:false}],
          linkURL:[ {value: linkURL ? linkURL : '', disabled:false}, [ Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
          url: [{value: url ? url : this.url, disabled:false} ,[Validators.required, Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
          name:[{value:name ? name : undefined, disabled:false}],
          filter:[{value:filter ? filter : undefined, disabled:false}],
          altTitle:[{value:altTitle ? altTitle : undefined, disabled:false}],
          fallbackUrl:[ {value:fallbackUrl ? fallbackUrl: undefined, disabled:false}, [ Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]]
        })

        break;
      }

      case 'callToAction':{
        const {id, type, filter,title, imageUrl,imageSize, logoUrl, socialNetworks,name, altTitle, fallbackUrl, iconAlignment} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value:id ? id : undefined, disabled:false}],
          title:[{value:title ? title : undefined, disabled:false}],
          imageSize:[{value:imageSize ? imageSize : undefined, disabled:false}],
          imageUrl: [{value:imageUrl ? imageUrl :undefined, disabled:false} ,[Validators.required, Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
          logoUrl:[{value:logoUrl ? logoUrl : undefined, disabled:false}],
          socialNetworks:[{value:socialNetworks ? socialNetworks : undefined, disabled:false}],
          type:[{value:type ? type : undefined, disabled:false}],
          name:[{value:name ? name : undefined, disabled:false}],
          filter:[{value:filter ? filter: undefined, disabled:false}],
          altTitle:[{value:altTitle ? altTitle : undefined, disabled:false}],
          fallbackUrl: [ {value:fallbackUrl ? fallbackUrl : undefined, disabled:false},[Validators.pattern(this.urlRegex),urlInvalidCharactersValidator()]],
          iconAlignment:[{value:iconAlignment ? iconAlignment : undefined, disabled:false}]
        })
        break;
      }

      case 'image':{
        const {id, type,filter, url, linkURL, source, copyright, subtitle, title,widgetStyle, position, size, name, fallbackUrl , altTitle} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value:id ? id : undefined, disabled:false}],
          type:[{value:type ? type : undefined, disabled:false}],
          url:[{value:url ? url : undefined, disabled:false}, [Validators.required, Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          linkURL:[{value: linkURL ? linkURL :'', disabled:false},[Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          source:[{value:source ? source : undefined, disabled:false}],
          copyright:[{value: copyright ? copyright : undefined, disabled:false}],
          subtitle:[{value: subtitle ? subtitle : undefined, disabled:false}],
          title:[{value: title ? title : undefined, disabled:false}],
          position:[{value: position ? position : undefined, disabled:false}],
          size:[{value: size ? size : undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          filter:[{value: filter ? filter :undefined, disabled:false}],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}],
          altTitle:[{value: altTitle ? altTitle : undefined, disabled:false}],
          fallbackUrl:[{value: fallbackUrl ? fallbackUrl : undefined, disabled:false},[Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]]
        })
        break;
      }

      case 'billboardVideo' : {
        const {id, type, filter, subtitle, url, previewPicture, coverImageURL, copyright, autoPlay, autoRePlay, muted, videoControls, size, name, altTitle} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled:false}],
          type:[{value: type ? type: undefined, disabled:false},],
          subtitle:[{value: subtitle ? subtitle : undefined, disabled:false}],
          url:[{value: url ? url : undefined, disabled:false} ,[Validators.required, Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          previewPicture:[{value: previewPicture ? previewPicture : undefined, disabled:false}],
          copyright:[{value: copyright ? copyright : undefined, disabled:false}],
          autoPlay:[{value: autoPlay ? autoPlay : false, disabled:false}],
          autoRePlay:[{value: autoRePlay ? autoRePlay : false, disabled:false}],
          muted:[{value: muted ? muted : false, disabled:false}],
          videoControls:[{value: videoControls ? videoControls : false, disabled:false}],
          size:[{value: size ? size : undefined, disabled:false}],
          name: [{value: name ? name : undefined, disabled:false}],
          filter:[{value: filter ? filter : undefined, disabled:false}],
          coverImageURL:[{value: coverImageURL ? coverImageURL : undefined, disabled:false}],
          altTitle:[{value: altTitle ? altTitle : undefined, disabled:false}]
        })
        break;
      }

      case 'splashVideo':{
        const {id,filter, url, type, copyright, title, autoPlay, autoRePlay, muted, coverImageURL, videoControls, size, name,altTitle } = data
        let {showMoreIndicator} = data
    
        if( showMoreIndicator == true)
        showMoreIndicator = true
    
        if(showMoreIndicator == false )
        showMoreIndicator = false
    
        if(showMoreIndicator == undefined)
        showMoreIndicator = true

        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled:false}],
          type:[{value: type ? type : undefined, disabled:false}],
          url:[{value: url ? url : undefined, disabled:false}, [Validators.required, Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          copyright:[{value: copyright ? copyright : undefined, disabled:false}],
          title:[{value: title ? title : undefined, disabled:false}],
          autoPlay:[{value: autoPlay ? autoPlay : false, disabled:false}],
          autoRePlay:[{value: autoRePlay ? autoRePlay : false, disabled:false}],
          muted:[{value: muted ? muted : false, disabled:false}],
          videoControls:[{value: videoControls ? videoControls : false, disabled:false}],
          size:[{value: size ? size : undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          filter:[{value: filter ? filter : undefined, disabled:false}],
          showMoreIndicator:[{value: showMoreIndicator, disabled:false}],
          coverImageURL:[{value: coverImageURL ? coverImageURL : undefined, disabled:false}],
          altTitle:[{value: altTitle ? altTitle : undefined, disabled:false}]
        })
        break;
      }

      case 'text':{
        const {id,filter, type, title, subtitle, text, image, imagePosition,widgetStyle, name, textAlignment} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value:id ? id : undefined, disabled:false}],
          type:[{value:type ? type : undefined, disabled:false}],
          title:[{value: title ? title : undefined, disabled:false}],
          subtitle:[{value: subtitle ? subtitle : undefined, disabled:false}],
          text:[{value: text ? text : undefined, disabled:false}],
          image:[{value: image ? image : undefined, disabled:false}],
          imageUrl:[ {value: image?.url ? image?.url : undefined, disabled:false} ,[Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          imageLinkURL:[{value: image?.linkURL ? image?.linkURL : undefined, disabled:false}  ,[Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          imageSize:[{value: image?.size ? image?.size : undefined, disabled:false} ],
          // imageDescription:[],
          imagePosition:[{value: imagePosition ? imagePosition : undefined, disabled:false} ],
          name:[{value: name ? name : undefined, disabled:false}],
          textAlignment:[{value:  textAlignment ? textAlignment : undefined, disabled:false} ],
          filter:[{value: filter ? filter :undefined, disabled:false}],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}],
          altTitle:[{value: image?.altTitle ? image?.altTitle : undefined, disabled:false}],
          imageFallbackUrl:[{value: image?.fallbackUrl ? image?.fallbackUrl: undefined, disabled:false} , [Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]]
        })
        break;
      }

      case 'video' :{
        const {id, filter,url, widgetStyle, showMoreIndicator, type, previewPicture, coverImageURL, layout, copyright, title, subtitle, autoPlay, autoRePlay, muted, videoControls,size, name, altTitle} = data

        this.widgetsDataForm = this.fb.group({
          id:[{ value: id ? id : undefined, disabled:false}],
          layout:[{ value: layout ? layout : 'standard', disabled:false}],
          type:[{ value: type ? type : undefined, disabled:false}],
          url:[{ value: url ? url : undefined, disabled:false},[Validators.required, Validators.pattern(this.urlRegex), urlInvalidCharactersValidator()]],
          previewPicture:[{ value: previewPicture ? previewPicture : undefined, disabled:false}],
          copyright:[{ value: copyright ? copyright : undefined, disabled:false}],
          title:[{ value: title ? title : undefined, disabled:false}],
          subtitle:[{ value: subtitle ? subtitle : undefined, disabled:false}],
          autoPlay:[{ value: autoPlay ? autoPlay : false, disabled:false}],
          autoRePlay:[{ value: autoRePlay ? autoRePlay : false, disabled:false}],
          muted:[{ value: muted ? muted : false, disabled:false}],
          videoControls:[{ value: videoControls ? videoControls : false, disabled:false}],
          size:[{ value: size ? size : undefined, disabled:false}],
          name:[{ value: name ? name : undefined, disabled:false}],
          filter:[{ value: filter ? filter : undefined , disabled:false}],
          widgetStyle:[{ value: widgetStyle ? widgetStyle : undefined, disabled:false}],
          coverImageURL:[{ value: coverImageURL ? coverImageURL : undefined, disabled:false}],
          altTitle:[{ value: altTitle ? altTitle : undefined, disabled:false}],
          showMoreIndicator:[{value: showMoreIndicator ? showMoreIndicator : undefined, disabled:false}]
        })
        break;
      }

      case 'images': {
        let {id, layout, type, title, subtitle, images, mediaURL, name, keyPath, filter, widgetStyle} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled:false}],
          layout:[{value: layout ? layout : undefined, disabled:false}],
          type:[{value: type ? type :undefined, disabled:false}],
          title:[{value: title ? title : undefined, disabled:false}],
          subtitle:[{value: subtitle ? subtitle :undefined, disabled:false}],
          images:[{value: images ? images : undefined, disabled:false}],
          mediaURL:[{value: mediaURL ? mediaURL : undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          keyPath:[{value: keyPath ?? '', disabled:false}],
          filter:[{value:  filter ? filter : undefined, disabled:false}],
          widgetStyle:[{value:  widgetStyle ? widgetStyle : undefined, disabled:false}]
        });
        
        break;
      }

      case 'buttons':{
      const {buttons,filter, buttonsStyle, cornerRadius, id, type, name, keyPath, widgetStyle} = data

        this.widgetsDataForm = this.fb.group({
          buttons:[{value: buttons ? buttons : [], disabled:false}],
          buttonsStyle:[{value: buttonsStyle ? buttonsStyle : undefined, disabled:false}],
          cornerRadius:[{value: cornerRadius ? cornerRadius : 0, disabled:false}],
          id:[{value: id ? id : undefined, disabled:false}],
          type:[{value: type ? type : undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          keyPath:[{value: keyPath ?? '', disabled:false}],
          filter:[{value: filter ? filter: undefined, disabled:false}],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}]
        })
        break;
      }

      case 'countdown':{
        const { type, id, /*title,*/ name, targetDate, targetDateKey, expiredMessage,filter, alignment, textColor, backgroundColor, widgetStyle} = data
        let date, valuerange1
        if(targetDate){
           date = isDateTimeGetTimeSeconds(targetDate)
          let dateEx = new Date(date).toLocaleDateString('de-DE',{year: 'numeric', month: '2-digit', day:'2-digit'}).split('.')
          const year = String(dateEx[2]).padStart(4,'0')
          valuerange1 = year +'-'+ dateEx[1] +'-' + dateEx[0] + 'T' + new Date(date).toLocaleTimeString('de-DE',{ hour: "2-digit", minute: "2-digit" })
        }
        
        this.widgetsDataForm = this.fb.group({
          type:[{value: type ? type : undefined, disabled:false}],
          id:[{value: id ? id : undefined, disabled:false}],
          // title:[],
          name:[{value: name ? name : undefined, disabled:false}],
          targetDate:[{value: valuerange1 ? valuerange1 : undefined, disabled:false}],
          targetDateKey:[{value: targetDateKey ? targetDateKey : undefined, disabled:false}],
          expiredMessage:[{value: expiredMessage ? expiredMessage : undefined, disabled:false}],
          filter:[{value: filter ? filter : undefined, disabled:false}],
          alignment:[{value: alignment ? alignment : undefined, disabled:false}],
          backgroundColor:[{value: backgroundColor ? backgroundColor : undefined, disabled:false}],
          textColor:[{value: textColor ? textColor : undefined, disabled:false} ],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}]
        })
        break;
      }

      case 'productRegistration':{
        const {id, filter,type, name, registeredView, registered, unregistered, image , style, fallbackUrl , widgetStyle } = data;
        const registeredViewKey = `registeredView_${this.passId}_${id}`;
        const storedRegisteredView = this.localStorageService.get(registeredViewKey);
        
        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled:false}],
          type:[{value: type ? type :undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          registeredView: [{value: registeredView ? registeredView : storedRegisteredView, disabled:false}],
          registeredShowImage:[{value: registered?.showImage ? registered?.showImage : undefined, disabled:false}],
          registeredText:[{value: registered?.text ? registered?.text : undefined, disabled:false}],
          registeredTextAlign:[{value: registered?.textAlign ? registered?.textAlign : undefined, disabled:false}],
          unregisteredShowImage:[{value: unregistered?.showImage ? unregistered?.showImage : undefined, disabled:false}],
          unregisteredText:[{value: unregistered?.text ? unregistered?.text : undefined, disabled:false}],
          imageUrl:[{value: image?.url ? image?.url : undefined, disabled:false}],
          imageDescription:[{value: image?.description ? image?.description : undefined, disabled:false}],
          imageSize:[{value: image?.size ? image?.size : undefined, disabled:false}],
          backgroundColor:[{value: style?.backgroundColor ? style?.backgroundColor : undefined, disabled:false}, [validColorValidator()]],
          foregroundColor:[{value: style?.foregroundColor ? style?.foregroundColor : undefined, disabled:false}, [validColorValidator()]],
          borderColor:[{value: style?.borderColor ? style?.borderColor : undefined, disabled:false}, [validColorValidator()]],
          borderWidth:[{value: style?.borderWidth ? style?.borderWidth : undefined, disabled:false}],
          filter:[{value: filter ? filter : undefined, disabled:false}],
          altTitle:[{value: image?.altTitle ? image?.altTitle : undefined, disabled:false}],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}],
          fallbackUrl:[{value: fallbackUrl ? fallbackUrl : undefined, disabled:false}]
        })
        break;
      }

      case 'form':{
        const { type, filter,sections, id, title, subtitle,name, submitTitle, widgetStyle, reloadDPP, submitAgainTitle, successMessage, workflowTemplateId, submitButtonStyle, submitButtonStyle_backgroundColor,submitButtonStyle_foregroundColor, submitButtonStyle_borderColor, submitButtonStyle_borderWidth, submitButtonStyle_cornerRadius } = data
        this.widgetsDataForm = this.fb.group({
          type:[{value: type ? type : "form", disabled:false}],
          sections:[{value: sections ? sections : undefined, disabled:false}],
          id:[{value: id ? id : undefined, disabled:false}],
          title:[{value: title ? title : undefined, disabled:false}],
          subtitle:[{value: subtitle ? subtitle : undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          submitTitle:[{value: submitTitle ? submitTitle : undefined, disabled:false}],
          submitAgainTitle:[{value: submitAgainTitle ? submitAgainTitle : undefined, disabled:false}],
          successMessage:[{value: successMessage ? successMessage : undefined, disabled:false}],
          reloadDPP:[{value: reloadDPP ? reloadDPP : undefined, disabled:false}],
          workflowTemplateId: [{value:  workflowTemplateId ? workflowTemplateId : undefined, disabled:false}],
          submitButtonStyle:[{value: submitButtonStyle ? submitButtonStyle : undefined, disabled:false}],
          filter:[{value: filter ? filter: undefined, disabled:false}],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}],
          submitButtonStyle_backgroundColor: [{value:submitButtonStyle_backgroundColor ? submitButtonStyle_backgroundColor : undefined, disabled:false}, [validColorValidator()]],
          submitButtonStyle_foregroundColor: [{value:submitButtonStyle_foregroundColor ? submitButtonStyle_foregroundColor : undefined, disabled:false}, [validColorValidator()]],
          submitButtonStyle_borderColor: [{value: submitButtonStyle_borderColor ? submitButtonStyle_borderColor : undefined, disabled:false}, [validColorValidator()]],
          submitButtonStyle_borderWidth: [{value: submitButtonStyle_borderWidth ? submitButtonStyle_borderWidth : undefined, disabled:false}],
          submitButtonStyle_cornerRadius: [{value: submitButtonStyle_cornerRadius ? submitButtonStyle_cornerRadius : undefined, disabled:false}]
        })
        break;
      }

      case 'composed': {
        const {id, type,filter, subtitle, title,content, name,widgetStyle } = data
        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled:false}],
          type:[{value: type ? type : undefined, disabled:false}],
          subtitle:[{value: subtitle ? subtitle : undefined, disabled:false}],
          title:[{value: title ? title : undefined, disabled:false}],
          content:[{value: content ? content : undefined, disabled:false}],
          name:[{value: name ? name : undefined, disabled:false}],
          filter:[{value:filter ? filter :undefined, disabled:false}],
          widgetStyle:[{value: widgetStyle ? widgetStyle : undefined, disabled:false}]
        })
        break;
      }

      case 'annotatedMap':{
        const {id, filter, type, style, layout, widgetStyle, title, subtitle, annotationGroup, annotations,name} = data

        this.widgetsDataForm = this.fb.group({
          id:[{value: id ? id : undefined, disabled:false}],
          type:[{value: type ? type : undefined, disabled:false}],
          style: [{value: style ? style : undefined, disabled: false}],
          layout:[{value:layout ? layout : undefined, disabled: false}],
          title:[{value: title ? title :undefined, disabled:false}],
          subtitle:[{value: subtitle ? subtitle : undefined, disabled: false}],
          annotationGroup:[{value: annotationGroup ? annotationGroup : undefined, disabled: false}],
          annotations:[{value: annotations ? annotations : undefined, disabled: false}],
          name:[{ value: name ? name : undefined, disabled: false}],
          filter: [{value: filter ? filter : undefined, disabled: false}],
          widgetStyle: [{value: widgetStyle ? widgetStyle : undefined, disabled: false}]
        })
        break;
      }
    }
  }

  initializeTranslationData(data, type) {
    this.dataOriginal = deepCopy( data)
    this.dataOriginal.originalLanguageData = true
    this.dataOriginal.fields = []

    this.oldData=deepCopy(data.values)
    this.widgetId = data.values.id ?? data.widgetId

    this.widgetsTranslatedForm = this.fb.group({
      url:[],
      linkURL:[],
      imageUrl:[],
      title:[],
      subtitle:[],
      expiredMessage:[],
      images:[],
      registeredText:[],
      unregisteredText:[],
      sections:[], 
      submitTitle:[], 
      submitAgainTitle:[], 
      successMessage:[],
      content:[],
      altTitle:[],
      buttons:[],
      text:[],
      textToSave:[],
      image:[],
      annotations:[]
    })

    if(type){
      this.title = this.translate.instant('pass.widgets.types.' + type)

      const {valuesTranslated, selectedLanguage} = data
      switch(type){
        case 'billboardImage': {
          let linkURL = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.linkURL']
          let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.altTitle']
          this.widgetsTranslatedForm.patchValue({ url,linkURL,altTitle })
          break;
        }

        case 'image': {
          let linkURL = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.linkURL']
          let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.altTitle']
          let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
          let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']
          this.widgetsTranslatedForm.patchValue({ url,linkURL,altTitle, title, subtitle })
          break;
        }

        case 'billboardVideo': {
          let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.altTitle']
          this.widgetsTranslatedForm.patchValue({url, altTitle})
          break;
        }

        case 'callToAction': {
          let imageUrl = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.imageUrl']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.altTitle']
          this.widgetsTranslatedForm.patchValue({imageUrl, altTitle})
          break;
        }

        case 'video': {
          let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
          let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.altTitle']
          this.widgetsTranslatedForm.patchValue({url, title, subtitle, altTitle})
          break;
        }

        case 'splashVideo': {
          let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.altTitle']
          this.widgetsTranslatedForm.patchValue({url, altTitle})
          break;
        }

        case 'countdown': {
          let expiredMessage = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.expiredMessage']
          this.widgetsTranslatedForm.patchValue({expiredMessage})
          break;
        }

        case 'images': {
          // let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
          let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']          
          
          let images
          const valuesImages = deepCopy(data.values?.images)
          valuesImages.forEach(image => {
            if( valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id + '.url'] )
              image.url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id + '.url']
  
            if( valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id +'.title'] )
            image.title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id +'.title']
  
            if( valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id +'.linkURL'] )
            image.linkURL = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id +'.linkURL']

            if( valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id +'.altTitle'] )
            image.altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + image.id +'.altTitle']
          });

          this.widgetsTranslatedForm.patchValue({title, subtitle, images:valuesImages})
          break;
        }

        case 'productRegistration':{
          let registeredText = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_registered.text']
          let unregisteredText = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_unregistered.text']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_image.altTitle']

          this.widgetsTranslatedForm.patchValue({registeredText, unregisteredText, altTitle})
          break;
        }

        case 'form':{
          let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
          let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']
          let submitTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.submitTitle']
          let submitAgainTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.submitAgainTitle']
          let successMessage = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.successMessage']
          
          let sections
          const valuesSections = deepCopy(data.values?.sections)
          valuesSections?.forEach(section => {  
            if( valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + section.id +'.title'] )
            section.title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_' + section.id +'.title']
  
            section?.fields.forEach(field => {
              // if(valuesTranslated[selectedLanguage +'.'+this.passId+ '_' + section.id + '_' + field.id + '.title'])
                field.title = valuesTranslated[selectedLanguage +'.'+this.widgetId+ '_' + section.id +'_' + field.id + '.title']

              if(field.type == "options"){
                field?.options.forEach(option => {
                  // if(valuesTranslated[selectedLanguage +'.'+ this.widgetId + '_' + section.id + '_' + field.id +'.options_' + option.id + '.title'])
                  option.title = valuesTranslated[selectedLanguage +'.'+ this.widgetId + '_' + section.id + '_' + field.id +'.options_' + option.id + '.title']
                });
              }
            });
          });

          this.widgetsTranslatedForm.patchValue({title, subtitle, sections:valuesSections, submitTitle, submitAgainTitle, successMessage})
          break;
        }

        case 'composed': {
          // let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
          let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
          let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']          
          
          let content
          const valuesContent = deepCopy(data.values?.content)
          valuesContent.forEach(contentNode => {
            this.readTranslationsOfContent(contentNode, data)
          });

          this.widgetsTranslatedForm.patchValue({title, subtitle, content:valuesContent})
          break;
        }

        case 'buttons':{
          let buttons = deepCopy(data.values?.buttons) ?? []
          if(buttons){
            buttons.forEach( (button, index) => {
              let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
              let url = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.url']
              button.title = title
              button.url = url
            })
            this.widgetsTranslatedForm.patchValue({buttons})
          }
          break;
        }

        case 'text':{
          let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
          let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']
          let text = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.text']
          let altTitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '_image.altTitle']
          this.widgetsTranslatedForm.patchValue({title, subtitle, text, altTitle})
          break;
        }

        case 'annotatedMap':{
            let title = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.title']
            let subtitle = valuesTranslated[selectedLanguage + '.' + this.widgetId + '.subtitle']          
            
            const valuesAnnotations = deepCopy(data.values?.annotations)
            valuesAnnotations.forEach(annotation => {
              if(annotation.dynamic){
                if(annotation.properties){
                  annotation.properties.title = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + annotation.id + '.properties.title']
                  annotation.properties.subtitle = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + annotation.id + '.properties.subtitle']
                  annotation.properties.linkURL = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + annotation.id + '.properties.linkURL']
                }
              }else{
                annotation.title = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + annotation.id + '.title']
                annotation.subtitle = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + annotation.id + '.subtitle']
                annotation.linkURL = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + annotation.id + '.linkURL']
              }
            });
  
            this.widgetsTranslatedForm.patchValue({title, subtitle, annotations:valuesAnnotations})
          break;
        }
      }
    }

    this.dragFileData = data.dragFileData
    this.dragFileDataOriginal = data.dragFileDataOriginal

  }

  readTranslationsOfContent(element, data){
    if(element.type == 'zstack' || element.type == 'hstack' || element.type == 'vstack'){
      const children = element.children
      children.forEach(child => {
        this.readTranslationsOfContent(child, data)
      });
    }

    if(element.attributes && element.attributes.text){
      element.attributes.text = data.valuesTranslated[data.selectedLanguage +'.'+this.widgetId+ '_' + element.id + '_attributes.text']
    }
  }

  showOriginal(){
    this.showOriginalActive = true
  }

  hideOriginal(){
    this.showOriginalActive = false
  }

  returnChangesWidgetTranslations($event){
    switch( this.data.type){
      case 'billboardImage':{
        const {url, linkURL, altTitle} = $event.translations
        this.widgetsTranslatedForm.patchValue({url, linkURL, altTitle})
        break;
      }

      case 'billboardVideo':{
        const { url, altTitle} = $event.translations
        this.widgetsTranslatedForm.patchValue({ url, altTitle})
        break;
      }

      case 'image':{
        const {url, linkURL, altTitle, title, subtitle} = $event.translations
        this.widgetsTranslatedForm.patchValue({url, linkURL, altTitle, title, subtitle})
        break;
      }

      case 'callToAction':{
        const {imageUrl, altTitle} = $event.translations
        this.widgetsTranslatedForm.patchValue({imageUrl,altTitle})
        break;
      }

      case 'video':{
        const {url, title, subtitle, altTitle} = $event.translations
        this.widgetsTranslatedForm.patchValue({url, title, subtitle, altTitle})
        break;
      }

      case 'splashVideo':{
        const { url, altTitle } = $event.translations
        this.widgetsTranslatedForm.patchValue({ url, altTitle })
        break;
      }

      case 'countdown':{
        const {expiredMessage} = $event.translations
        this.widgetsTranslatedForm.patchValue({expiredMessage})
        break;
      }

      case 'images':{
        const {title, subtitle, images} = $event.translations
        this.widgetsTranslatedForm.patchValue({title, subtitle, images})
        break;
      }

      case 'productRegistration':{
        const {registeredText, unregisteredText, altTitle} = $event.translations
        this.widgetsTranslatedForm.patchValue({registeredText,unregisteredText, altTitle})
        // this.widgetsTranslatedForm.patchValue({registeredText: $event.registeredText, unregisteredText: $event.unregisteredText, altTitle: $event.altTitle})
        break;
      }

      case 'form':{
        let { sections, title, subtitle, submitTitle,submitAgainTitle, successMessage} = $event.translations

        this.widgetsTranslatedForm.patchValue({subtitle, title, sections, submitTitle, submitAgainTitle, successMessage})

        break;
      }

      case 'composed':{
        let {title, subtitle,content} = $event.translations

        this.widgetsTranslatedForm.patchValue({title, subtitle ,content})
        break;
      }

      case 'buttons':{
        const { buttons} = $event.translations
        this.widgetsTranslatedForm.patchValue({buttons})
        break;
      }

      case 'text':{
        const {title, subtitle, altTitle, text} = $event.translations
        this.widgetsTranslatedForm.patchValue({title, subtitle, altTitle, text})
        break;
      }

      case 'annotatedMap':{
        let {title, subtitle,annotations} = $event.translations
        this.widgetsTranslatedForm.patchValue({title, subtitle ,annotations})
        break;
      }
    }
    if($event.saveDisabled)
      this.saveDisabled = $event.saveDisabled
    if($event.validForm)
      this.validForm = $event.validForm
  }

  returnChangesWidget($event){
    if($event.type === "form" || $event.type === "composed" || $event.type === "annotatedMap" 
      || $event.type === "billboardImage" 
      || $event.type === "billboardVideo"
      || $event.type === "splashVideo"
      || $event.type === "text"
      || $event.type === "image"
      || $event.type === "images"
      || $event.type === "video"
      || $event.type === "buttons"
      || $event.type === "callToAction"
      || $event.type === "countdown"
      || $event.type === "productRegistration"
    ){
      this.widgetsDataForm.patchValue($event.data)
      this.saveDisabled = $event.saveDisabled
      this.validForm = $event.validForm
    }else
    this.widgetsDataForm.patchValue($event)
  }

  returnDataToSaveWidget($event){
    const {type, data} = $event
    switch(type){
      case 'buttons':{
        this.dialogRef.close([data, true, ]);
        break;
      }
    }
    this.commentService.progressSpin.emit(false)
  }

  returnDataToSaveTranslationsWidget($event){
    const {type, data} = $event
    switch(type){
      case 'buttons':{
        const newtranslations = this.widgetService.getWidgetTranslationsFormatedData(this.data.translateData, this.widgetsTranslatedForm.value, this.widgetId, this.data.type)

        this.dialogRef.close([newtranslations, true]);
        break;
      }
    }
    this.commentService.progressSpin.emit(false)
  }

  checkdyanimcContentUrl(value){
    if(value?.match(/\${(.+)\}/))
    return true
    else
    return false
  }

  async saveChanges(){
    if(this.data.translateMode){
      if(this.data.type != "buttons"){
        const data = this.widgetService.getWidgetTranslationsFormatedData(this.data.translateData, this.widgetsTranslatedForm.value, this.widgetId, this.data.type)
        this.commentService.progressSpin.emit(false)
        this.dialogRef.close([data, true]);
      }else{
        this.clickToSave = true // change to true to detect changes on widget form component and prepare data
      }

      
    }else{
      let form = this.widgetsDataForm.value
      this.commentService.progressSpin.emit(true)
  
      switch(this.data.type){
        case 'billboardImage' : {
          this.commentService.progressSpin.emit(true)
          if(form.url)
           this.dynamicUrl = this.checkdyanimcContentUrl(form.url)

          if(form.url && !this.dynamicUrl){
            if(form?.imageSize?.length == 0 || !form?.imageSize || (form?.imageSize && form.imageSize[0] == 0 && form.imageSize[1] == 0)  ){
              const url = supportUrlStructure(form.url, this.passId, this.settingsService.contextId$)
              try{
                await this.uploadService.calculateImgFileSize(url).then(value => {
                  this.widgetsDataForm.patchValue({imageSize: value})
                  form = this.widgetsDataForm.value
                })
              }catch(error){
                console.log(error)
              }
            }
          }else{
            if(form.imageSize) {
              this.widgetsDataForm.patchValue({imageSize: undefined})
              form = this.widgetsDataForm.value
            }
          }
    
          if(form?.linkURL === 'https://') {
            this.widgetsDataForm.patchValue({linkURL: undefined})
            form = this.widgetsDataForm.value
          }
    
          if(form.url){
            this.commentService.progressSpin.emit(false)
            this.dialogRef.close([form, true]);
          }else{
            this.commentService.progressSpin.emit(false)
            const message = this.translate.instant("SnackBarConstants.COVER_IMAGE_NEEDED")
            this.commentService.addSnackBar.emit(message)
          }
          break;
        }

        case 'billboardVideo':{
          if(form.url){
            this.dialogRef.close([form, true]);
            this.commentService.progressSpin.emit(false)
          }
          else{
            const message = this.translate.instant("SnackBarConstants.VIDEO_NEEDED")
            this.commentService.addSnackBar.emit(message)
          }
          break;
        }

        case 'callToAction': {
          if(form.imageUrl){    
            form.socialNetworks = form.socialNetworks.filter( social => {
              if(social.url)
                return social
            })
            this.commentService.progressSpin.emit(false)
            this.dialogRef.close([form, true]);
          } else {
            const message = this.translate.instant("SnackBarConstants.COVER_IMAGE_NEEDED")
            this.commentService.addSnackBar.emit(message)
          }
          break;
        }

        case 'image':{

          if(form.url){
            this.commentService.progressSpin.emit(false)
            if(!form.name)
              form.name = form.title ? form.title : undefined
      
            if(form.linkURL == 'https://')
              this.widgetsDataForm.patchValue({linkURL : undefined})
      
            if(!this.checkdyanimcContentUrl(form.url))
              this.loadUrlSize(form.url, 'size')
              
            this.dialogRef.close([form, true, , this.widgetsDataForm.value.translations]);
      
          }else{
            const message = this.translate.instant("SnackBarConstants.COVER_IMAGE_NEEDED")
            this.commentService.addSnackBar.emit(message)
          }
          break;
        }

        case 'splashVideo':{
          this.commentService.progressSpin.emit(true)
          if(!form.url){
            this.commentService.progressSpin.emit(false)
            const message = this.translate.instant("SnackBarConstants.VIDEO_NEEDED")
            this.commentService.addSnackBar.emit(message)
          }else {            
            this.dialogRef.close([form, true, ]);
            this.commentService.progressSpin.emit(false)
          }
          break;
        }

        case 'text': {
          if(!form.name){
            form.name = form.title ? form.title : undefined
          }
          const data = removeUndefined( form)
          this.commentService.progressSpin.emit(false);
          this.dialogRef.close([data, true]);
          break;
        }

        case 'video' : {
          if(form?.layout=='standard'){
            if(!form.name)
              form.name = form.title ? form.title : undefined
          }
          const data = removeUndefined( form)
          if(form.url){
            this.dialogRef.close([data, true, ]);
            this.commentService.progressSpin.emit(false)
          }else{
            this.commentService.progressSpin.emit(false)
            const message = this.translate.instant("SnackBarConstants.VIDEO_NEEDED")
            this.commentService.addSnackBar.emit(message)
          }
          break;
        }

        case 'images': {
          if(!form.name)
            form.name = form.title ? form.title : undefined
          form.keyPath = form.keyPath?.trim() || undefined
          if (form.keyPath) {
            if (!Array.isArray(form.images) || !form.images.some(image => !!image?.url)) {
              const message = this.translate.instant('SnackBarConstants.COVER_IMAGE_NEEDED')
              this.commentService.addSnackBar.emit(message)
              this.commentService.progressSpin.emit(false)
              break;
            }
            this.dialogRef.close([form, true]);
            this.commentService.progressSpin.emit(false)
            break;
          }
          const dataprepared = prepareToSaveImages(form, this.widgetNumber)
          if(dataprepared.error){
            const message = this.translate.instant(dataprepared.error.translate)
            this.commentService.addSnackBar.emit(message)
          }else{
            this.dialogRef.close(dataprepared.data ?? [form, true]);
            this.commentService.progressSpin.emit(false)
          }
          break;
        }

        case 'buttons':{
          this.clickToSave = true
          break;
        }

        case 'countdown':{
          const {expiredMessage, targetDate} = form
          if(expiredMessage && targetDate){
            this.commentService.progressSpin.emit(true)
            if(targetDate){
              let date = new Date(targetDate)
              const minDate = new Date('1970-01-01T00:00').getFullYear()
      
              this.widgetsDataForm.patchValue({targetDate: date})
              if(date.getTime() < minDate)
                this.widgetsDataForm.patchValue({targetDate: new Date('1970-01-01T00:00')})
            }
            const data = removeUndefined(this.widgetsDataForm.value)
            this.dialogRef.close([data, true])
            this.commentService.progressSpin.emit(false)
          }else{
            const message = this.translate.instant("SnackBarConstants.MANDATORY_FIELDS_EMPTY")
            this.commentService.addSnackBar.emit(message)
            this.commentService.progressSpin.emit(false)
          }

          break;
        }

        case 'productRegistration':{
          const { imageUrl, id, registeredView, registeredShowImage, unregisteredShowImage } = form
      

          if(!this.checkdyanimcContentUrl(imageUrl))
            this.loadUrlSize(imageUrl, 'imageSize')
          
          // Transform the flat form values to nested structure
          const transformedData = transformToNestedStructure(form);
          removeUndefined(transformedData)
      
          // Generate a unique key for registeredView 
          const registeredViewKey = `registeredView_${this.passId}_${id}`;
          // Save local storage
          if (registeredView !== undefined) {
            this.localStorageService.set(registeredViewKey, registeredView);
          }
      
          if(registeredShowImage || unregisteredShowImage){
            if(imageUrl ) {
              this.commentService.progressSpin.emit(false);
              this.dialogRef.close([transformedData, true, ]);
            }else{
              const message = this.translate.instant("SnackBarConstants.COVER_IMAGE_NEEDED")
              this.commentService.addSnackBar.emit(message)
            }
          }else{
            this.commentService.progressSpin.emit(false);
            this.dialogRef.close([transformedData, true, ]);
          }

          break;
        }

        case 'form':{
          if(!form.name)
            form.name = form.title ? form.title : undefined
          const data = getFormatedDataFormWidget(form)
          removeUndefined(data)
          this.dialogRef.close([ data, true])
          this.commentService.progressSpin.emit(false)
          break;
        }

        case 'composed':{
          if(!form.name)
            form.name = form.title ? form.title : undefined
          const data = removeUndefined( form)
          this.dialogRef.close([data, true]);
          this.commentService.progressSpin.emit(false)
          break;
        }

        case 'annotatedMap':{
          if(!form.name)
            form.name = form.title ? form.title : undefined
          const data = removeUndefined( form)

          this.dialogRef.close([data,true, ,]);
          this.commentService.progressSpin.emit(false)
          break;
        }
      }
    }
    
  }

  handleFormChange(form: FormGroup) {
    this.saveDisabled = !form.valid;
  }

  async loadUrlSize(url, field){
    const form = this.widgetsDataForm.value

    if(form[field]?.length == 0 || !form[field] || (form[field] && form[field][0] == 0 && form[field][1] == 0) ){
      const urlData = supportUrlStructure(form.url, this.passId, this.settingsService.contextId$)
      await this.uploadService.calculateImgFileSize(urlData).then(value => {
        this.widgetsDataForm.patchValue({[field]: value})
      })
    }
  }
}
